import { useFormikContext } from 'formik';
import { useEffect } from 'react';

const ScrollToError = (props: any): any => {
  const { callback } = props;
  const { submitCount, isValid, errors } = useFormikContext();
  useEffect(() => {
    if (submitCount > 0 && !isValid) {
      const firstErrorKey = Object.keys(errors)[0];
      if (callback) {
        callback(firstErrorKey);
      }
      const element: any = document.querySelector(`[name="${firstErrorKey}"]`);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [submitCount, isValid, errors]);
  return null;
};

export default ScrollToError;
